import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Paragraph from '@mos-cat/paragraph';
import MosSelect from '@mos-front-components/public/es/components/MosSelect';

import setChatInterval from '../../store/timeSlotChat/actions';
import { saveDraft } from '../../store/draft/actions';
import chatIntervalSelector from './chatIntervalSelector';

import './ChatInterval.pcss';

class ChatInterval extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.setChatInterval(value);
  }

  render() {
    const { saveDraft } = this.props;

    if (!this.props.show) {
      return null;
    }

    return (
      <div>
        <div className="ChatInterval">
          <Paragraph>
            <MosSelect
              dropListView
              placeholder="Дата и время онлайн-чата"
              value={this.props.currentValue || ''}
              suggestions={this.props.chatIntervalsText}
              onChange={text => {
                this.handleChange(text);
                saveDraft();
              }}
            />
          </Paragraph>
          <Paragraph>
            Апелляция о несогласии с выставленными баллами по результатам ГИА
            подается в течение 2-х рабочих дней, следующих за официальным днем
            объявления результатов экзамена по соответствующему учебному
            предмету. Вы можете выбрать из представленных на интерактивной форме
            предпочтительную дату и время проведения онлайн-чата.
          </Paragraph>
          <Paragraph>
            Дата и время проведения онлайн-чата могут быть изменены после
            обработки заявления. Точную дату и время онлайн-чата назначает
            апелляционная комиссия. В течение 2-х рабочих дней с момента
            регистрации заявления на рассмотрение апелляции о несогласии с
            выставленными баллами в личный кабинет на Портале вам будет
            направлено уведомление, в котором будет указано время и дата
            проведения онлайн чата.
          </Paragraph>
        </div>
      </div>
    );
  }
}

ChatInterval.propTypes = {
  chatIntervalsText: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentValue: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  setChatInterval: PropTypes.func.isRequired
};

export default connect(chatIntervalSelector, dispatch =>
  bindActionCreators(
    {
      setChatInterval,
      saveDraft
    },
    dispatch
  )
)(ChatInterval);
